export function trackById(index, data) {
    return data ? data.id : index;
}
